import { FadeUp } from "./Reveal";
import { useLang } from "./LanguageContext";

const copy = {
  en: {
    kicker: "Business Models · For Patrizia's",
    h2: <>Three ways to <em className="italic">bring it to life.</em></>,
    models: [
      { n: "01", title: "Aruba Sunset Experience", tag: "Signature Destination", body: "A nightly tableside mozzarella ritual timed to the Caribbean sunset — a first-of-its-kind draw for Aruba's premium diners and resort guests, and a reason to book the Patrizia's room." },
      { n: "02", title: "NY/NJ Family Events", tag: "Existing Locations", body: "Turn the existing New York and New Jersey rooms into destinations for family celebrations and private parties — the live show as the centerpiece, on nights you already own." },
      { n: "03", title: "Pinsa & Fuoco Concept", tag: "Phase 2 · Highest Ceiling", body: "The complete build: contemporary Roman pinsa paired with the live mozzarella ritual — as a standalone venue or brand extension, the strongest long-term upside." },
    ],
  },
  it: {
    kicker: "Modelli di Business · Per Patrizia's",
    h2: <>Tre modi per <em className="italic">darle vita.</em></>,
    models: [
      { n: "01", title: "Aruba Sunset Experience", tag: "Destinazione Signature", body: "Un rituale serale di mozzarella al tavolo, sincronizzato con il tramonto caraibico — un'attrazione senza precedenti per gli ospiti premium di Aruba e un motivo in più per prenotare la sala Patrizia's." },
      { n: "02", title: "Eventi di Famiglia NY/NJ", tag: "Sedi Esistenti", body: "Trasforma le sale di New York e New Jersey in destinazioni per celebrazioni di famiglia e feste private — lo show dal vivo come cuore della serata, nelle sale che già possiedi." },
      { n: "03", title: "Pinsa & Fuoco Concept", tag: "Fase 2 · Massimo Potenziale", body: "Il progetto completo: pinsa romana contemporanea unita al rituale della mozzarella dal vivo — come locale indipendente o estensione del brand, il potenziale più forte nel lungo periodo." },
    ],
  },
  ru: {
    kicker: "Бизнес-модели · Для Patrizia's",
    h2: <>Три способа <em className="italic">воплотить это в жизнь.</em></>,
    models: [
      { n: "01", title: "Aruba Sunset Experience", tag: "Фирменное направление", body: "Вечерний ритуал моцареллы у стола под карибский закат — первое в своём роде притяжение для премиальных гостей Арубы." },
      { n: "02", title: "Семейные события NY/NJ", tag: "Существующие площадки", body: "Залы Нью-Йорка и Нью-Джерси как места семейных торжеств и частных вечеров — живое шоу в центре." },
      { n: "03", title: "Pinsa & Fuoco Concept", tag: "Фаза 2 · Максимум", body: "Полный проект: современная римская пинса и живой ритуал моцареллы — сильнейший потенциал в долгую." },
    ],
  },
  es: {
    kicker: "Modelos de Negocio · Para Patrizia's",
    h2: <>Tres formas de <em className="italic">darle vida.</em></>,
    models: [
      { n: "01", title: "Aruba Sunset Experience", tag: "Destino Signature", body: "Un ritual nocturno de mozzarella junto a la mesa, sincronizado con el atardecer caribeño — una atracción sin precedentes para los comensales premium de Aruba." },
      { n: "02", title: "Eventos Familiares NY/NJ", tag: "Sedes Existentes", body: "Convierte los salones de Nueva York y Nueva Jersey en destinos para celebraciones familiares y fiestas privadas — el show en vivo como corazón de la velada." },
      { n: "03", title: "Pinsa & Fuoco Concept", tag: "Fase 2 · Máximo Potencial", body: "El proyecto completo: pinsa romana contemporánea unida al ritual de la mozzarella en vivo — el mayor potencial a largo plazo." },
    ],
  },
};

export const PatriziasBusinessModels = () => {
  const { lang } = useLang();
  const t = copy[lang];
  return (
    <section id="business-models" className="py-24 md:py-40 bg-gradient-to-b from-bg to-[#ece1cd]" data-testid="business-models-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <FadeUp className="mb-14 md:mb-20 max-w-2xl">
          <p className="font-sans text-xs uppercase tracking-[0.35em] text-terracotta mb-5">{t.kicker}</p>
          <h2 className="font-serif text-4xl md:text-6xl text-ink leading-[1.05]">{t.h2}</h2>
        </FadeUp>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {t.models.map((m, i) => (
            <FadeUp key={m.n} delay={i * 0.1}>
              <div className="h-full bg-surface border border-ink/10 rounded-sm p-8 flex flex-col" data-testid={`model-card-${i + 1}`}>
                <span className="font-serif italic text-5xl text-terracotta/80 leading-none">{m.n}</span>
                <p className="font-sans text-[11px] uppercase tracking-[0.25em] text-ink-soft mt-6 mb-2">{m.tag}</p>
                <h3 className="font-serif text-3xl text-ink mb-4">{m.title}</h3>
                <p className="font-sans text-ink-soft leading-relaxed flex-1">{m.body}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>
    </section>
  );
};
